<template>
  <div v-if="template === 'default'" class="comment-area">
    <button
      @click="displayCommentArea = !displayCommentArea"
      class="comment-button"
      style="color: #c1c1c1;"
    >
      <font-awesome-icon :icon="['fas', 'comment-alt']" />
      <span>Comentar</span>
    </button>

    <textarea
      v-if="displayCommentArea"
      v-model="comment"
      @change="$emit('input', $event.target.value)"
      name="comment"
      id="comment-textarea"
      rows="2"
      class="form-control"
    />
  </div>
  <div
    v-else
    style="display: flex; align-items: center; justify-content: center;"
    class="comment-area-big"
  >
    <button
      v-if="clickButton"
      class="comment-button-big"
      style="color: #c1c1c1; margin-left: -45%;"
    >
      <font-awesome-icon :icon="['fas', 'comment-alt']" />
      <span>Comentar</span>
    </button>

    <textarea
      v-if="clickButton"
      v-model="comment"
      @change="$emit('input', $event.target.value)"
      name="comment"
      id="comment-textarea-big"
      rows="2"
      class="form-control"
    />
  </div>
</template>

<script>
export default {
  name: 'Comment',

  data: () => ({
    displayCommentArea: false,
    comment: null,
  }),

  props: {
    template: { type: String, required: true, default: 'default' },
    clickButton: { type: Boolean, default: false },
  },
};
</script>

<style scoped lang="scss">
.comment-button {
  font-size: 12px;
  background: transparent;
  border: 0;
}

.comment-button-big {
  background: transparent;
  border: 0;
  //margin-left: -45%;
}

.comment-area {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  textarea {
    margin-top: 1px;
    width: 100%;
  }
}

.comment-area-big {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  textarea {
    margin-top: 8px;
    width: 54%;
  }
}

.comment-area-big.comment-big {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/metrics/comment-area/index.vue